module.exports = "/assets/data/6a35815c1cda57e1dd523509c96e105b-B96.data.json";